import {Vue} from 'vue-property-decorator';

const initialState = () => {
  return {
    swStock: null
  }
};

const state = initialState();

const mutations = {
  SET_SELECTED_SKU(state, payload) {
    Vue.set(state, 'selectedSku', payload);
  },
  UPDATE_STOCK(state, stock) {
    state.swStock = stock
  }
};

const actions = {
  setSwStock({state, commit}, payload) {
    commit('UPDATE_STOCK', payload)
  },
  setSelectedSku({state, commit}, sku) {
    commit('SET_SELECTED_SKU', sku);
  }
};

const getters = {
  swStock: state => state.swStock,
  selectedSku: state => state.selectedSku
};

const CatalogProductView = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};

export default CatalogProductView;
